import { useCallback, useMemo } from 'react';
import { Delete2LineIcon, Modal } from 'ui';
import { useRemoveAccount } from '../../../queries';

type P = {
  logOut: () => void;
};

export const useRemoveAccountConfirmModal = ({ logOut }: P) => {
  const [modal, contextHolder] = Modal.useModal();

  const { isPending: isRemoveAccountIsLoading, mutateAsync: removeAccount } = useRemoveAccount();

  const confirm = useCallback(
    ({ deleteReason }: { deleteReason?: string }) => {
      const handleRemoveAccount = async () => {
        await removeAccount(
          { deleteReason },
          {
            onSuccess() {
              logOut();
            },
          },
        );
      };

      modal.confirm({
        content: "The request will be sent to admin. After admin's approval, your account will be removed.",
        icon: <Delete2LineIcon type="error" />,
        okText: 'Remove',
        onOk: handleRemoveAccount,
        title: 'Are you sure you want to remove your account?',
        type: 'error',
      });
    },
    [modal, removeAccount, logOut],
  );

  return useMemo(
    () => ({
      confirm,
      contextHolder,
      isLoading: isRemoveAccountIsLoading,
    }),
    [confirm, contextHolder, isRemoveAccountIsLoading],
  );
};
